import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Swapstamp | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="swapstamp" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
						Swapstamp
						</div>

						<div className="projects-brand-link">
							<a
								href="https://swapstamp.com"
								target="_blank"
								rel="noreferrer"
							>
								<div className="projects-brand-link-icon">
									<img
										src="swapstamp.svg"
										alt="Swapstamp"
										className="projects-brand-link-image"
									/>
								</div>
								<div className="projects-brand-link-text">
									Swapstamp Digital Loyalty Programs
								</div>
							</a>
						</div>

						<div className="projects-video-box">
							<div className="projects-video-frame">
								<iframe
									src="https://www.youtube.com/embed/3XdQmnosvxQ"
									title="Swapstamp Video"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									referrerPolicy="strict-origin-when-cross-origin"
									allowFullScreen
								/>
							</div>
						</div>

						<div className="subtitle projects-subtitle">
						<p>Swapstamp is being shaped as a loyalty product with a clear operational split between platform foundations, access control, backend services, vendor workflows, customer flows, and wallet delivery.</p>
						<p>The current implementation in the product repo already shows a real system design: Terraform-managed AWS infrastructure, Cognito-based authentication, Lambda services behind API Gateway, dedicated vendor and customer paths, and wallet integrations for both Apple and Google ecosystems.</p>
						<p>This section breaks the product into six topics that matter from both a product and engineering perspective. Each topic represents a concrete slice of the system that already exists in code and can later be expanded into a full article.</p>
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
